import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  TableContainer,
  Table,
  TableBody,
  Typography,
  ImageListItem,
  TableRow,
  TableHead,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Moment from 'react-moment';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export default function PolicyDatasPreview({ previewData }) {
  return (
    <Grid container md={12} spacing={2} mb={1} mt={1} key={previewData.id}>
      <Grid item md={12}>
        <Card
          sx={{
            border: '1px dashed grey'
          }}
        >
          {previewData?.groups?.map((group) => {
            return (
              <>
                {group.formGroupInputs.length > 0 ? (
                  <CardHeader title={group.groupName} />
                ) : null}
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableBody>
                        {group.formGroupInputs?.map(
                          (formGroupInput, formGroupInputIndex) => {
                            return (
                              <StyledTableRow key={formGroupInputIndex}>
                                <StyledTableCell
                                  component="th"
                                  scope="row"
                                  sx={{ width: 300 }}
                                >
                                  {formGroupInput.masterInputField.label}
                                </StyledTableCell>
                                <StyledTableCell sx={{ width: 800 }}>
                                  {formGroupInput.masterInputField.type ===
                                  'Checkbox' ? (
                                    formGroupInput.masterInputField.checkedValues.join(
                                      ', '
                                    )
                                  ) : formGroupInput.masterInputField.type ===
                                    'List' ? (
                                    // printing list datas
                                    <RFQListTable
                                      formGroupInput={formGroupInput}
                                    />
                                  ) : //End of list datas
                                  formGroupInput.masterInputField.type ===
                                    'Calendar' ? (
                                    // check date exist
                                    formGroupInput.masterInputField.value ? (
                                      <Moment format="D/MMM/YYYY">
                                        {formGroupInput.masterInputField.value}
                                      </Moment>
                                    ) : (
                                      'N/A'
                                    )
                                  ) : //Check End
                                  formGroupInput.masterInputField.type ===
                                    'StaticForm' ? (
                                    <>
                                      {formGroupInput?.masterInputField?.staticInputDatas?.map(
                                        (staticInputData) => {
                                          return (
                                            <Typography gutterBottom>
                                              {staticInputData.label}
                                              &nbsp; : &nbsp;
                                              {staticInputData.value}
                                            </Typography>
                                          );
                                        }
                                      )}
                                    </>
                                  ) : formGroupInput.masterInputField.type ===
                                    'FileUpload' ? (
                                    <Grid container spacing={1} mt={1}>
                                      {formGroupInput.masterInputField.uploadedFiles?.map(
                                        (uploadedFile) => {
                                          return (
                                            <Grid item xs={2}>
                                              <ImageListItem key="1">
                                                <img
                                                  src={`${uploadedFile}?w=164&h=2000&objectFit=contain`}
                                                  srcSet={`${uploadedFile}?w=164&h=2000&objectFit=contain`}
                                                  alt={'image'}
                                                  loading="lazy"
                                                />
                                              </ImageListItem>
                                            </Grid>
                                          );
                                        }
                                      )}
                                    </Grid>
                                  ) : formGroupInput.masterInputField.value ? (
                                    formGroupInput.masterInputField.value
                                  ) : (
                                    ' N/A'
                                  )}
                                </StyledTableCell>
                              </StyledTableRow>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </>
            );
          })}
        </Card>
      </Grid>
    </Grid>
  );
}

function RFQListTable(formGroupInput) {
  return (
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          {formGroupInput.formGroupInput?.masterInputField?.sublistStructure?.map(
            (tableColumn) => {
              return <TableCell>{tableColumn.label}</TableCell>;
            }
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {formGroupInput.formGroupInput?.listRows?.map((tableRowData) => {
          return (
            <TableRow
              key={1}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 }
              }}
            >
              {tableRowData?.map((cellData) => {
                return (
                  <TableCell component="th" scope="row">
                    {cellData.value ? cellData.value : 'N/A'}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
      {formGroupInput.formGroupInput.enableFooterSection ? (
        <TableHead>
          <TableRow className="listTableFooter">
            {formGroupInput.formGroupInput?.footerInputs?.map((footerInput) => {
              return footerInput.enableFooter ? (
                <TableCell>{footerInput.total}</TableCell>
              ) : (
                <TableCell> </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
      ) : null}
    </Table>
  );
}
